export default __webpack_public_path__ + "static/media/view.3a1f6b27.svg";